// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "259a6d7eca7e9d6284d6a117728ea14cc957d5c3/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};